function dm_c16() {

    if ($('.card-initials').length) {
        $('.card-initials a').on('click', function (e) {
            e.preventDefault();
            const target = $(this).attr('href');
            if ($(target).length) {
                $('html, body').animate({
                    scrollTop: $(target).offset().top - 100
                }, 600);
            }
        });
    }

}

export { dm_c16 };
